import SearchOffIcon from "@mui/icons-material/SearchOff";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import CenterScreen from "../common/CenterScreen";
import theme from "../theme";

interface NotFoundProps {
  buttonLabel: string;
  navigateTo: string;
}

const NotFound = ({ buttonLabel, navigateTo }: NotFoundProps) => {
  const navigate = useNavigate();

  return (
    <CenterScreen>
      <SearchOffIcon
        sx={{
          transform: "scale(4)",
          color: theme.palette.primary.main,
        }}
      />
      <Typography
        sx={{
          fontSize: "24px",
          fontWeight: "bold",
          marginTop: "64px",
          color: theme.palette.grey[800],
        }}
      >
        Page Not Found
      </Typography>
      <Typography
        sx={{
          fontSize: "20px",
          marginTop: "20px",
          marginBottom: "30px",
          fontWeight: 500,
          color: theme.palette.grey[600],
        }}
      >
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate(navigateTo, { replace: true })}
      >
        {buttonLabel}
      </Button>
    </CenterScreen>
  );
};

export default NotFound;
